// src/components/Header.js
import React from 'react';
import './Header.css';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const today = new Date().toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long'
  });
  const navigate = useNavigate();

  return (
    <div className="header-top">
      {/* 左侧日期 */}
      <div className="header-top-left">{today}</div>

      {/* 右侧 我的信息 + 系统公告 */}
      <div className="header-top-right">
        <span className="header-link" onClick={() => navigate('/my')}>我的信息</span>
        <span className="system-notice">系统公告：欢迎使用本源AI</span>
      </div>
    </div>
  );
};

export default Header;
